// extracted by mini-css-extract-plugin
export default {"ratingContent":"Ratings_ratingContent__IyxNi","starIconGrey":"Ratings_starIconGrey__bxKMD","ratingWrapper":"Ratings_ratingWrapper__TaTMb","ratingValue":"Ratings_ratingValue__hnAGs"};